import { Component } from '@ecs/Component';
import { WeaponMode } from '@/types';

export class StandardWeapon implements Component {
  readonly type = 'StandardWeapon';

  constructor(
    public cooldown: number = 200,
    public range: number = 150,
    public energyCost: number = 10,
    public bulletSpeed: number = 8,
    public bulletColor: string = '#00ffff',
    public damage: number = 1,
    public mode: WeaponMode = 'auto',
    public lastShot: number = 0,
    public projectileCount: number = 1,
    public spreadAngle: number = 0 // total fan angle in radians across all projectiles
  ) {}
}